import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/globals.css';
import { App } from '@/App';
import { installPreloadErrorListener } from '@/lib/chunkReload';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// S021.5b §1.2: een voor-geladen bestand dat na een deploy weg is → één keer herladen.
installPreloadErrorListener();

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
